<template>
    <div class="col mt-4">
        <div
            @click="onProducerClick"
            class="card producer-card"
            :class="{ 'card--active': activePromos }"
        >
            <div class="card-body">
                <figure class="c-fig c-fig--16x9">
                    <img class="c-fig__img" :src="data.logo.urls.small" alt />
                </figure>
                <h5 class="h3 card-title-lg">{{ data.name }}</h5>
                <div class="card-stats">
                    <span class="card-stats-label">{{
                        isLotteryUser
                            ? 'Tutaj zobaczysz liczbę opublikowanych promocji'
                            : 'Liczba opublikowanych promocji:'
                    }}</span>
                    <span class="card-stats-value">{{ activePromos }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    computed: {
        isLotteryUser() {
            return this.$store.getters.isLotteryUser
        },
        activePromos() {
            return this.$store.getters.getCompanyActivePromos(this.data.id)
        }
    },
    methods: {
        onProducerClick() {
            if (this.isLotteryUser) {
                this.$store.dispatch('onLotteryUserNoPermission')
            } else {
                this.$store.dispatch('clearFilters', 'promotions').then(() => {
                    this.$store
                        .dispatch('setFilter', {
                            filter: 'company_id',
                            value: [this.data.id],
                            moduleName: 'promotions'
                        })
                        .then(() => {
                            this.$router.push(
                                this.$router.resolve({ name: 'promo-list' })
                                    .href
                            )
                        })
                })
            }
        }
    }
}
</script>